import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const ProjectBanner = () => {
  const [isVisible, setIsVisible] = useState(() => {
    if (typeof window === 'undefined') return true;
    return window.localStorage.getItem('projectBannerClosed') !== 'true';
  });
  const { t } = useTranslation();

  // Add effect to adjust body padding when banner visibility changes
  useEffect(() => {
    const banner = document.querySelector('.project-banner');
    if (!banner) return undefined;

    const bannerHeight = isVisible ? banner.offsetHeight : 0;

    document.documentElement.style.setProperty('--banner-height', `${bannerHeight}px`);

    return () => {
      document.documentElement.style.setProperty('--banner-height', '0px');
    };
  }, [isVisible]);

  // Handle closing the banner
  const closeBanner = () => {
    setIsVisible(false);
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('projectBannerClosed', 'true');
    }
    document.documentElement.style.setProperty('--banner-height', '0px');
  };

  return (
    <div
      aria-hidden={!isVisible}
      className="project-banner fixed top-0 left-0 right-0 z-[19] bg-paper-deep text-[color:var(--ink-invert)] py-2.5 px-8 flex justify-center items-center text-[13px] transition-all duration-300 ease-in-out max-md:px-4 max-[500px]:px-3 max-[500px]:text-xs"
      style={{
        transform: isVisible ? "translateY(0)" : "translateY(-100%)",
        opacity: isVisible ? 1 : 0,
      }}
    >
      <div className="flex items-center gap-4 max-w-[1200px] mx-auto max-md:gap-2 max-md:pr-8 max-[500px]:justify-center">
        <span className="text-white/60 max-md:hidden">{t("Visit our ongoing project")}</span>
        <span className="text-white/60 md:hidden">Visit</span>

        <a
          href="https://agri.hyphentech.africa/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gold no-underline font-medium transition-colors duration-200 inline-flex items-center gap-1.5 hover:underline underline-offset-4"
        >
          <span className="max-md:hidden">{t("Check out AgriHyphen AI")}</span>
          <span className="md:hidden">AgriHyphen AI</span>
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.5 3C3.5 2.72386 3.72386 2.5 4 2.5H8.5C8.77614 2.5 9 2.72386 9 3V7.5C9 7.77614 8.77614 8 8.5 8C8.22386 8 8 7.77614 8 7.5V4.20711L3.35355 8.85355C3.15829 9.04882 2.84171 9.04882 2.64645 8.85355C2.45118 8.65829 2.45118 8.34171 2.64645 8.14645L7.29289 3.5H4C3.72386 3.5 3.5 3.27614 3.5 3Z"
              fill="currentColor"
            />
          </svg>
        </a>
      </div>
      <button
        className="absolute right-4 bg-transparent border-none text-white/50 text-xl cursor-pointer py-1 px-2 leading-none transition-colors duration-200 hover:text-white max-[500px]:right-2 max-[500px]:text-base"
        onClick={closeBanner}
        aria-label="Close banner"
      >
        ×
      </button>
    </div>
  );
};

export default ProjectBanner;
